import 'scss/component/easydropdown.scss'
import 'babel-polyfill'
import { config } from 'config'
import 'js/libs/easydropdown/src/jquery.easydropdown.js'
import country from 'js/libs/country.js'
import { cookie } from 'js/libs/utils-cookie'

import 'js/libs/gt'
import { getQueryString } from 'js/libs/utils'
import { Base64 } from 'js-base64'

const setSSOCookie = function (accountId, ssoSessionId, url) {
  url = url || location.href
  location.href = `${config.AUTH_SITE}SSOService/login/setcookies?ssoSessionId=${ssoSessionId}&account_id=${accountId}&url=${Base64.encode(url)}&_=${Math.random()}`
}

const loginSuccess = function (accountId, ssoSessionId, url, isRegist) {
  setTimeout(function () {
    if (getQueryString('jump') === 'login') {
      setSSOCookie(accountId, ssoSessionId, url || document.referrer || window.location.href)
    } else {
      setSSOCookie(accountId, ssoSessionId, url || window.location.href)
    }
  }, isRegist ? 0 : 2000)
}

const registSuccess = function (data) {
  // 注册成功，先隐藏弹框，再显示
  $('.modal-wrapper-register').hide()
  $('.login-success-box').show()
  $('.go-getfree').click(function () {
    $('.login-success-box').hide()
    window.open('/free?from=index')
    setTimeout(() => {
      $('.login-success-box').hide()
      loginSuccess(data.account_id, data.ssoSessionId, document.referrer || window.location.href, true)
    }, 1e3)
  })
  $('.login-success-box .close-login-success').click(function () {
    $('.login-success-box').hide()
    loginSuccess(data.account_id, data.ssoSessionId, document.referrer || window.location.href, true)
  })
}

let dataTemp
// 页面链接跳转模块
var clickModel = {
  addEvent: function () {
    $('#gologin').click(function () {
      $('.register-model').hide()
      $('.login-model').show()
    })
    $('#goemail').click(function () {
      $('.login-model').hide()
      $('.email-model').show()
      $('#account_name').focus()
      $('#ssologin_form')[0].reset()
    })
    $('#gologinTel').click(function () {
      $('.email-model').hide()
      $('.login-model').show()
      $('#account_telephone_login').focus()
    })
    $('.link-skip').click(function () {
      if (dataTemp) {
        registSuccess(dataTemp)
      }
    })
  },
  init: function () {
    var that = this
    that.addEvent()
  }
}

var privacyPolicyModal = {
  addEvent: function () {
    $('#privacy_policy_btn').click(function () {
      $('#privacy_policy').hide()
      $('.modal-wrapper-logo').show()
      $('.register-model').show()
    })
  },
  init: function () {
    this.addEvent()
    // document.getElementById('p_p_c').oncontextmenu = function () {
    //   event.returnValue = false
    // }
  }
}

// 注册模块
var registerModel = {
  validatorRegister: '',
  result: {},
  captchaObj: null,
  // 初始化区号下拉框
  dropdownInit: function () {
    // 手机号区号下拉框绑定
    const eartharea = {
      data: {
        $country: $('#telarea')
      },
      init: () => {
        // country.countryList.splice(0, 0, ['', '86', '中国', ''])
        eartharea.render('$country', country.countryList)
      },
      render: (type, data) => {
        var html = ''
        var item = '<option value="{val}" data-a="{datae}" data-b="{dataz}" data-c="{datan}">{value}</option>'
        for (let i = 0; i < data.length; i++) {
          html += item.replace('{value}', '(+' + data[i][1] + ')' + data[i][2]).replace('{val}', data[i][1]).replace('{datae}', data[i][3]).replace('{dataz}', data[i][4]).replace('{datan}', '(+' + data[i][1] + ')')
        }
        eartharea.data[type].html(html)
        if (eartharea.data[type].easyDropDown) {
          eartharea.data[type].easyDropDown('destroy')
          eartharea.data[type].easyDropDown({cutOff: 10})
        }
      }
    }
    eartharea.init()
  },
  // 极验验证方法
  geetestApi: function () {
    var that = this
    $.ajax({
      url: `${config.AUTH_SITE}SSOService/login/gee-captcha?t=${(new Date()).getTime()}`,
      type: 'get',
      dataType: 'jsonp',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          that.captchaObj = captchaObj
          captchaObj.onReady(function () {
            captchaObj.verify()
          }).onSuccess(function () {
            that.result = captchaObj.getValidate()
            if (!that.result) {
              return alert('请完成验证')
            }
            var parames = {
              mobile: $('input[name="register_telephone"]').val()
            }
            $.ajax({
              url: `${config.AUTH_SITE}SSOService/login/phone/check`,
              type: 'get',
              dataType: 'json',
              data: parames,
              xhrFields: {
                withCredentials: true
              },
              crossDomain: true,
              success: function (result) {
                if (result.flag) {
                  // 获取验证码
                  var that = registerModel
                  that.eventList.getCode()
                } else {
                  if (result.code !== 0) {
                    let error = result.desc
                    $('#register_error_tip').text(error).prev().show()
                  }
                }
              }
            })
          })
        })
      }
    })
  },
  // 倒计时
  getCodeInterval: function () {
    var $btn = $('#getCode')
    var $timeInterval = $('.register-time-interval')
    var time = 60// 定义时间变量。用于倒计时用
    var timer = null// 定义一个定时器；
    $btn.hide() // 将按钮隐藏
    $timeInterval.show()
    timer = setInterval(function () { // 开启定时器。函数内执行
      $('.register-time-interval').text(time + '秒后重发')// 点击发生后，文本内容变成之前定义好的时间值。
      time--// 时间值自减
      if (time === -1) { // 判断,当时间值小于等于0的时候
        $btn.show()
        $timeInterval.hide()
        clearInterval(timer) // 清除定时器
      }
    }, 1000)
  },
  eventList: {
    // 获取验证码
    getCode: function () {
      var that = registerModel // 调用后端接口，然后判断验证码是否获取成功，成功显示倒计时，不成功给个提示按扭不动
      var tel1 = $('.tel-box .dropdown .selected').text()
      var tel = tel1.substr(1)
      var parames = {
        countryCode: tel,
        mobile: $('input[name="register_telephone"]').val(),
        geetest_challenge: that.result.geetest_challenge,
        geetest_validate: that.result.geetest_validate,
        geetest_seccode: that.result.geetest_seccode ? Base64.encode(that.result.geetest_seccode) : ''
      }
      $.ajax({
        url: `${config.AUTH_SITE}SSOService/mobile/send-verify-code`,
        type: 'POST',
        dataType: 'json',
        data: parames,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function (data) {
          if (data.flag) {
            that.getCodeInterval()
          } else {
            if (data.code !== 0) {
              let error = data.desc
              $('#register_error_tip').text(error).attr({
                title: error
              }).prev().show()
            }
          }
        }
      })
    },
    // 注册，先校验，校验通过调用后端接口ajax请求
    register: function () {
      var tel1 = $('.tel-box .dropdown .selected').text()
      var tel = tel1.substr(1)
      var parames = {
        countryCode: tel, // 国别码
        mobile: $('input[name="register_telephone"]').val(), // 手机号
        verifyCode: $('input[name="register_yzm"]').val(), // 验证码
        password: $('input[name="register_psw"]').val() // 密码
      }
      $.mask()
      $.ajax({
        url: `${config.AUTH_SITE}SSOService/login/phone-quick-register`,
        type: 'get',
        dataType: 'json',
        data: parames,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function (result) {
          $.mask('hide')
          if (result.flag) {
            if (result.code === 0) {
              registSuccess(result.data)
            }
          } else {
            if (result.code !== 0) {
              let error = result.desc
              $('#register_error_tip').text(error).prev().show()
              if (result.code === -3) {
                $('#register_error_tip').text('验证码错误，请重新填写').prev().show()
              }
              if (result.code === 20011) {
                $('#register_error_tip').text('手机号已注册，可直接登录').prev().show()
              }
            }
          }
        }
      })
    }
  },
  addEvent: function () {
    var that = this
    // 验证表单事件
    that.validatorRegister = $('#ssoregister_form').validate({
      errorPlacement: function (error, element) {
        error.appendTo('.form-item-error')
      },
      showErrors: function (errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#register_error_tip').empty().text(errorList[0].message).prev().show()
        } else {
          $('#register_error_tip').empty().prev().hide()
        }
      },
      submitHandler: function () {
        // 调用注册方法
        that.eventList.register()
      },
      rules: {
        register_telephone: {
          required: true,
          isMobile: true
        },
        register_yzm: {
          required: true
        },
        register_psw: {
          required: true,
          isPwd: true
        },
        register_pswcheck: {
          required: true,
          equalTo: '#register_psw'
        },
        register_agreement: {
          required: true
        }
      },
      messages: {
        register_telephone: {
          required: '请填写手机号',
          isMobile: '手机号格式错误，请重新输入'
        },
        register_yzm: {
          required: '请填写验证码'
        },
        register_psw: {
          required: '请输入密码',
          isPwd: '密码6-20位，且包含数字和字母'
        },
        register_pswcheck: {
          required: '请重复输入密码',
          equalTo: '两次输入密码不一致，请重新输入'
        },
        register_agreement: {
          required: '请接受服务协议'
        }
      }
    })
    // 增加密码至少8位且必须是字母和数字组合的正则表达式
    jQuery.validator.addMethod('isPwd', function (value, element) {
      return this.optional(element) || /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)
    }, '密码6-20位，且包含数字和字母。')
    $('.register-model .dropdown ul li').click(function () {
      var num1 = $('#telarea option:selected').attr('data-c')
      var num2 = num1.substr(1)
      var num = num2.substr(0, num2.length - 1)
      $('.register-model .dropdown .selected').text(num)
      // 其他国家移除判断手机号格式是否正确的规则
      if ($('.tel-box .dropdown .selected').text() !== '+86') {
        $('#register_telephone').rules('remove', 'isMobile')
      } else {
        $('#register_telephone').rules('add', 'isMobile')
      }
    })
    $('#getCode').click(function () {
      $('#register_yzm').val('')
      $('#ssoregister_form').validate().element($('#register_telephone'))
      if ($('#register_error_tip').text() === '') {
        if (that.captchaObj) {
          that.captchaObj.verify()
        } else {
          that.geetestApi()
        }
      }
    })
  },
  init: function () {
    var that = this
    that.dropdownInit()
    that.addEvent()

    // $('#privacy_policy_show').click(function () {
    //   $('.register-model').hide()
    //   $('.modal-wrapper-logo').hide()
    //   $('#privacy_policy').show()
    // })
    // 下拉框默认选中中国区号
    $('.register-model .dropdown ul li').each(function () {
      let str1 = $(this).text()
      if (str1 === '(+86)中国') {
        $('.dropdown .selected').click()
        $(this).click()
        $('.dropdown ul li:eq(0)').click()
      }
    })
    // 国号码长度适应改变
    $('.register-model .dropdown .selected').bind('DOMSubtreeModified', () => {
      if ($('.tel-box .dropdown .selected').text().length === 3) {
        $('.tel-box .dropdown').css('width', '67px')
        $('.tel-box .line').css('left', '65px')
        $('.tel-box .form-telephone').css('margin-left', '75px')
      }
      if ($('.tel-box .dropdown .selected').text().length === 4) {
        $('.tel-box .dropdown').css('width', '76px')
        $('.tel-box .line').css('left', '75px')
        $('.tel-box .form-telephone').css('margin-left', '84px')
      }
      if ($('.tel-box .dropdown .selected').text().length === 5) {
        $('.tel-box .dropdown').css('width', '85px')
        $('.tel-box .line').css('left', '84px')
        $('.tel-box .form-telephone').css('margin-left', '93px')
      }
    })
  }
}
// 手机号登录模块
var loginModel = {
  validator: '',
  result: {},
  captchaObj: null,
  accountId: '',
  dropdownInit: function () {
    // 手机号区号下拉框绑定
    const eartharea = {
      data: {
        $country: $('#telarea_login')
      },
      init: () => {
        // country.countryList.splice(0, 0, ['', '86', '中国', ''])
        eartharea.render('$country', country.countryList)
      },
      render: (type, data) => {
        var html = ''
        var item = '<option value="{val}" data-a="{datae}" data-b="{dataz}" data-c="{datan}">{value}</option>'
        for (let i = 0; i < data.length; i++) {
          html += item.replace('{value}', '(+' + data[i][1] + ')' + data[i][2]).replace('{val}', data[i][1]).replace('{datae}', data[i][3]).replace('{dataz}', data[i][4]).replace('{datan}', '(+' + data[i][1] + ')')
        }
        eartharea.data[type].html(html)
        if (eartharea.data[type].easyDropDown) {
          eartharea.data[type].easyDropDown('destroy')
          eartharea.data[type].easyDropDown({cutOff: 10})
        }
      }
    }
    eartharea.init()
  },
  // 倒计时
  getCodeInterval: function () {
    var $btn = $('#getCode_login')
    var $timeInterval = $('.login-time-interval')
    var time = 60// 定义时间变量。用于倒计时用
    var timer = null// 定义一个定时器；
    $btn.hide() // 将按钮隐藏
    $timeInterval.show()
    timer = setInterval(function () { // 开启定时器。函数内执行
      $timeInterval.text(time + '秒后重发')// 点击发生后，文本内容变成之前定义好的时间值。
      time--// 时间值自减
      if (time === -1) { // 判断,当时间值小于等于0的时候
        $btn.show()
        $timeInterval.hide()
        clearInterval(timer) // 清除定时器
        $timeInterval.text('60秒后重发')
      }
    }, 1000)
  },
  eventList: {
    login: function () {
      // 登录，先校验，校验通过调用后端接口ajax请求
      var tel1 = $('.login-box .dropdown .selected').text()
      var tel = tel1.substr(1)
      var parames = {
        countryCode: tel, // 国别码
        mobile: $('input[name="account_telephone_login"]').val(), // 手机号
        verifyCode: $('input[name="account_yzm_login"]').val(), // 验证码
        isAct: $('#phonelogin_is_act').get(0).checked
      }
      $.mask()
      SSO.mobileLogin(parames, function (result) {
        $.mask('hide')
        // 登录出错的回调
        let deserror = result.desc
        $('#login_error_tip').text(deserror).prev().show()
      }, function (result) {
        // 登录成功的回调
        $.mask('hide')
        var that = loginModel
        that.accountId = result.data.account_id
        if (result.data.isNew === '1') {
          dataTemp = result.data
          $('.login-model').hide()
          $('.loginpwd-model').show()
        } else {
          $('.modal-wrapper-register').hide()
          $('.loginbox').show()
          $('.login').append('<i class="duigou"></i>')
          if (result.code === 0) {
            let data = result.data
            loginSuccess(data.account_id, data.ssoSessionId)
          }
        }
      })
    }
  },
  addEvent: function () {
    var that = this
    // 验证表单事件
    that.validator = $('#phonelogin_form').validate({
      errorPlacement: function (error, element) {
        error.appendTo('.form-item-error')
      },
      showErrors: function (errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#login_error_tip').empty().text(errorList[0].message).prev().show()
        } else {
          $('#login_error_tip').empty().prev().hide()
        }
      },
      submitHandler: function () {
        // 调用注册方法
        that.eventList.login()
      },
      rules: {
        account_telephone_login: {
          required: true,
          isMobile: true
        },
        account_yzm_login: {
          required: true
        }
      },
      messages: {
        account_telephone_login: {
          required: '请填写手机号',
          isMobile: '手机号格式错误，请重新输入'
        },
        account_yzm_login: {
          required: '请填写验证码'
        }
      }
    })
    $('.login-model .dropdown ul li').click(function () {
      var num1 = $('#telarea_login option:selected').attr('data-c')
      var num2 = num1.substr(1)
      var num = num2.substr(0, num2.length - 1)
      $('.login-model .dropdown .selected').text(num)
      // 其他国家移除判断手机号格式是否正确的规则
      if ($('.login-box .dropdown .selected').text() !== '+86') {
        $('#account_telephone_login').rules('remove', 'isMobile')
      } else {
        $('#account_telephone_login').rules('add', 'isMobile')
      }
    })
  },
  init: function () {
    var that = this
    that.dropdownInit()
    that.addEvent()
    // 下拉框默认选中中国区号
    $('.login-model .dropdown ul li').each(function () {
      let str1 = $(this).text()
      if (str1 === '(+86)中国') {
        $('.login-model .dropdown .selected').click()
        $(this).click()
      }
    })
    // 国号码长度适应改变
    $('.login-box .dropdown .selected').bind('DOMSubtreeModified', () => {
      if ($('.login-box .dropdown .selected').text().length === 3) {
        $('.login-box .dropdown').css('width', '67px')
        $('.login-box .line-tel').css('left', '65px')
        $('.login-box .form-telephone').css('margin-left', '75px')
      }
      if ($('.login-box .dropdown .selected').text().length === 4) {
        $('.login-box .dropdown').css('width', '76px')
        $('.login-box .line-tel').css('left', '75px')
        $('.login-box .form-telephone').css('margin-left', '84px')
      }
      if ($('.login-box .dropdown .selected').text().length === 5) {
        $('.login-box .dropdown').css('width', '85px')
        $('.login-box .line-tel').css('left', '84px')
        $('.login-box .form-telephone').css('margin-left', '93px')
      }
    })

    $('#getCode_login').click(function () {
      $('#account_yzm_login').val('')
      $('#phonelogin_form').validate().element($('#account_telephone_login'))
      if ($('#login_error_tip').text() === '') {
        var tel1 = $('.login-box .dropdown .selected').text()
        var tel = tel1.substr(1)
        SSO.getMobileCode({
          countryCode: tel,
          mobile: $('input[name="account_telephone_login"]').val()
        }, (result) => {
          if (result.flag) {
            that.getCodeInterval()
          } else {
            if (result.code !== 0) {
              let deserror = result.desc
              $('#login_error_tip').text(deserror).prev().show()
            }
          }
        })
      }
    })
  }
}
// 账号密码登录模块（沿用老版sso）
var traditionalLoginModel = {
  validator: '',
  elements: {
    ssologinForm: $('#ssologin_form'),
    loginErrorTip: $('#account_login_error_tip'),
    accountName: $('#account_name'),
    accountPwd: $('#account_pwd'),
    isAct: $('#is_act')
  },
  eventList: {
    toLogin: function () {
      var that = traditionalLoginModel
      SSO.login({
        accountName: that.elements.accountName.val().trim(),
        accountPwd: that.elements.accountPwd.val().trim(),
        isAct: that.elements.isAct.get(0).checked
      }, function (result) {
        // 登录出错的回调
        $('#account_login_error_tip').text(result.desc).prev().show()
      }, function (result) {
        $('.modal-wrapper-register').hide()
        $('.loginbox').show()
        $('.login').append('<i class="duigou"></i>')
        let data = result.data
        loginSuccess(data.account_id, data.ssoSessionId)
      })
    }
  },
  addEvent: function () {
    var that = traditionalLoginModel
    // 验证表单事件
    that.validator = $('#ssologin_form').validate({
      errorPlacement: function (error, element) {
        error.appendTo('.form-item-error')
      },
      showErrors: function (errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#account_login_error_tip').empty().text(errorList[0].message).prev().show()
        } else {
          $('#account_login_error_tip').empty().prev().hide()
        }
      },
      submitHandler: function () {
        // 调用sso登录方法
        that.eventList.toLogin()
      },
      rules: {
        account_name: {
          required: true
        },
        account_pwd: {
          required: true
        }
      },
      messages: {
        account_name: {
          required: '不能为空'
        },
        account_pwd: {
          required: '不能为空'
        }
      }
    })

    // $('#emialButton').click(function () {
    //   let accountName = traditionalLoginModel.elements.accountName.val().trim()
    //   let accountPwd = traditionalLoginModel.elements.accountPwd.val().trim()
    //   if (!accountName) {
    //     traditionalLoginModel.elements.accountName.focus()
    //   } else if (!accountPwd) {
    //     traditionalLoginModel.elements.accountPwd.focus()
    //   } else {
    //     submitForm()
    //   }
    // })
  },
  init: function () {
    var that = traditionalLoginModel
    that.addEvent()
    // 账号密码登陆添加错误提示的图标
    // $('#ssologin_form .info-content-commontip').bind('DOMSubtreeModified', () => {
    //   var $error = $('#ssologin_form .info-content-commontip')
    //   if ($error.text() !== '') {
    //     $error.prev().show()
    //   } else {
    //     $error.prev().hide()
    //   }
    // })
  }
}
// 设置登录密码模块
var loginpwdModel = {
  eventList: {
    loginpwd: function () {
      // 注册，先校验，校验通过调用后端接口ajax请求
      var parames = {
        uid: loginModel.accountId,
        password: $('input[name ="account_psw"]').val()// 密码
      }
      $.mask()
      $.ajax({
        url: `${config.AUTH_SITE}SSOService/login/password/set`,
        type: 'POST',
        dataType: 'json',
        data: parames,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function (result) {
          $.mask('hide')
          if (result.flag) {
            // setcookie
            if (result.code === 0) {
              registSuccess(result.data)
            }
          } else {
            if (result.code !== 0) {
              let error = result.desc
              $('#loginpwd_error_tip').text(error).prev().show()
            }
          }
        }
      })
    }
  },
  addEvent: function () {
    var that = this
    // 验证表单事件
    $('#loginpwd_form').validate({
      errorPlacement: function (error, element) {
        error.appendTo('.form-item-error')
      },
      showErrors: function (errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#loginpwd_error_tip').empty().text(errorList[0].message).prev().show()
        } else {
          $('#loginpwd_error_tip').empty().prev().hide()
        }
      },
      submitHandler: function () {
        // 调用注册方法
        that.eventList.loginpwd()
      },
      rules: {
        account_psw: {
          required: true,
          isPwd: true
        },
        account_pswcheck: {
          required: true,
          equalTo: '#account_psw'
        }
      },
      messages: {
        account_psw: {
          required: '请输入密码',
          isPwd: '密码6-20位，且包含数字和字母'
        },
        account_pswcheck: {
          required: '请重复输入密码',
          equalTo: '两次输入密码不一致，请重新输入'
        }
      }
    })
    // 增加密码至少8位且必须是字母和数字组合的正则表达式
    jQuery.validator.addMethod('isPwd', function (value, element) {
      return this.optional(element) || /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)
    }, '密码6-20位，且包含数字和字母。')
  },
  init: function () {
    var that = this
    that.addEvent()
  }
}
clickModel.init()
registerModel.init()
loginModel.init()
traditionalLoginModel.init()
loginpwdModel.init()
privacyPolicyModal.init()

export {
  clickModel,
  registerModel,
  loginModel,
  traditionalLoginModel,
  loginpwdModel,
  privacyPolicyModal
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-new-login.js